import { useState, useEffect } from "react";
import logger from "../../util/logger";

import { useAuthState } from "react-firebase-hooks/auth";

import { auth, db } from "../../util/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

import { Modal, ModalBody } from "reactstrap";

import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";

const RewardHistoryModal = () => {
  // eslint-disable-next-line
  const [user] = useAuthState(auth);

  const [showModal, setShowModal] = useState(false);

  const { t } = useTranslation("common");

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const [rewardHistory, setRewardHistory] = useState([]);
  const fetchRewardHistory = async () => {
    try {
      const q = query(
        collection(db, "rewardRedemptions"),
        where("redeemerUid", "==", user.uid)
      );
      const docs = await getDocs(q);
      const history = docs.docs.map((doc) => doc.data());
      logger.debug("Fetched reward history:", history);
      setRewardHistory(history);
    } catch (error) {
      console.error("Error fetching reward history:", error);
    }
  };

  // Fetch reward history when the modal is opened
  useEffect(() => {
    if (showModal && rewardHistory.length === 0) {
      fetchRewardHistory();
    }
    // eslint-disable-next-line
  }, [showModal]);

  return (
    <>
      <button
        onClick={toggleModal}
        className="secondaryBtn"
        style={{ marginRight: "0.5rem" }}
      >
        {t("history").toUpperCase()}
      </button>
      <Modal
        id="rewardHistoryModal"
        isOpen={showModal}
        toggle={toggleModal}
        size={"lg"}
      >
        <ModalBody>
          <div className="modalHeader">
            <div></div>
            <IoClose onClick={closeModal} />
          </div>
          <div>
            <h1>{t("rewardHistory").toUpperCase()}</h1>
            <div style={{ marginTop: "1rem" }}>
              {rewardHistory.length === 0 ? (
                <p>{t("noRewardHistory")}</p>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          borderBottom: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left",
                        }}
                      >
                        {t("date")}
                      </th>
                      <th
                        style={{
                          borderBottom: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left",
                        }}
                      >
                        {t("reward")}
                      </th>
                      <th
                        style={{
                          borderBottom: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left",
                        }}
                      >
                        {t("tickets")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rewardHistory.map((entry, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                        }}
                      >
                        <td
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "8px",
                          }}
                        >
                          {new Date(
                            entry.redemptionDate.seconds * 1000
                          ).toLocaleDateString()}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "8px",
                          }}
                        >
                          {entry.rewardName}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "8px",
                          }}
                        >
                          {entry.rewardPriceInTickets}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default RewardHistoryModal;
